import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AutentificacionService } from '@services/autentificacion.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class YaEstaLogueadoGuard  {

  constructor(private router:Router, private autentificacionService:AutentificacionService ){}
  
  canActivate() {

    if (!this.autentificacionService.estaLogueado()) {

      return true;

    } else {

      this.router.navigate(['']);
      return false;
    }
  }
  
}
